<template>
  <div>
    <div style="padding: 15px 30px" class="light_blue_holder">
      <div class="flex flex-wrap justify-between items-center mb-4">
        <h4>Notes</h4>
      </div>
    </div>
    <div style="padding: 15px 30px">
      <vs-collapse>
        <vs-collapse-item
          class="light_blue_holder mb-2"
          v-for="(note, noteIndex) in noteList"
          :key="noteIndex"
        >
          <div class="header" slot="header">
            <div>
              <h6>{{ note.title }}</h6>
              <small
                >{{ note.createdBy.first_name }}
                {{ note.createdBy.last_name }}</small
              >
            </div>
            <vs-dropdown
              style="margin-left: 5px; cursor: pointer"
              vs-custom-content
              
            >
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-more-vertical"
            ></vs-button>

              <vs-dropdown-menu style="min-width: 100px" class="modal_dropdown_menu">
                <vs-dropdown-item
                @click.stop="notesDownload(note.id)"
                  >Download</vs-dropdown-item
                >
                <vs-dropdown-item
                @click.stop="pdfPreview(note.id)"
                  >Print</vs-dropdown-item
                >              
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <div v-html="note.body">
          </div>
          <div v-if="note.file.length > 0">
              <div
                v-for="(file, index) in note.file"
                :key="index"
                style="background: #e6f5f6;
                 border-radius: 10px;
                  padding: 25px 12px;
                  margin: 10px 0;
                "
              >
                  <!-- <img :src="file.file_path" alt=""> -->
                  <i
                    v-if="file.file_type.includes('pdf')"
                    class="material-icons"
                    style="color: teal"
                    >picture_as_pdf</i
                  >
                  <div v-else-if="video_array.includes(file.file_type)">
                    <video width="100%" height="500px" controls :src="file.file_path"></video>
                  </div>
                  
                  <img
                    v-else-if="image_array.includes(file.file_type)"
                    :src="file.file_path"
                    style="max-width: 100%"
                  />

                  <div v-else-if="audio_array.includes(file.file_type)">
                    <audio class="w-full" controls :src="file.file_path" :type="file.file_type" >
                  </audio>
                  </div>
                <div  v-else-if="
                      file.file_type.includes('doc') ||
                      file.file_type.includes('docx')"  class="flex flex-wrap items-center"
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="40"
                    height="40"
                    viewBox="0 0 172 172"
                    style="fill: #000000"
                  >
                    <g
                      fill="none"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g fill="#9b59b6">
                        <path
                          d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                  <b>{{file.file_name}}</b>
              </div>
                  <div v-else class="flex flex-wrap items-center">
                    <span class="material-icons-outlined">
                    description
                  </span>
                  <b>{{file.file_name}}</b>
                  </div>
                 
              </div>
            </div>
        </vs-collapse-item>
        <p class="text-center" v-if="noteList.length==0">No notes found.</p>
      </vs-collapse>
    </div>
    <div v-if="pdfPreviewModal">
      <PdfPreviewModalComponent
        :pdfPreviewModal="pdfPreviewModal"
        :pdfDetails="pdfDetails"
        @pdfPreviewModalClose="pdfPreviewModalClose"
      />
    </div>
  </div>
</template>
<script>
import { calenderNoteList } from '@/api/schedulerApi.js'
import { notesDownloadApi } from '@/api/calenderActions.js'
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import PdfPreviewModalComponent from '@/views/pages/schedule/pdfPreview.vue'


export default {
  components: {
    editor: Editor,
    axios,
    PdfPreviewModalComponent
  },
  props: {
    schedule_id: {
      default: 0
    },
    course_id: {
      default: 0
    }
  },
  data () {
    return {
      pdfPreviewModal: false,
      pdfDetails: null,
      customer_id: localStorage.getItem('customer_id'),
      noteList: [],
      video_array:['mpeg', 'mp4', 'mpg', 'mpe', 'qt', 'mov', 'mxu', 'm4u', 'flv', 'asf', 'asx', 'wmv', 'wm', 'wmx', 'avi', 'ogv', 'movie'],
      audio_array:['au', 'snd', 'mid', 'midi', 'kar', 'mpga', 'mp2', 'mp3', 'aif', 'aiff', 'aifc', 'm3u', 'wma', 'wax', 'ram', 'ra', 'wav'],
      image_array:['bmp', 'cgm', 'gif', 'ief', 'jpeg', 'jpg', 'jpe', 'png', 'svg', 'tiff', 'tif', 'djvu', 'djv', 'wbmp', 'ras', 'ico', 'pnm', 'pbm', 'pgm', 'ppm', 'rgb', 'xbm', 'psd', 'xpm', 'xwd'],
    }
  },
  methods: {
    pdfPreviewModalClose () {
      this.pdfPreviewModal = false
    },
    async pdfPreview (id) {
      const { data } = await notesDownloadApi(this.customer_id, id)
      this.openInNewTab(data.data.url)
      // this.pdfDetails = noteDetails
      // this.pdfPreviewModal = true
    },
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href
      }).click()
    },
    async notesDownload (id) {
      const { data } = await notesDownloadApi(this.customer_id, id)
      this.downloadItem({
        url: data.data.url,
        label: data.data.name
      })
      this.showSuccessMessage(
        'Success',
        'Notes downloaded successfully',
        'success'
      )
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'mime' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    async fetchCalenderNoteList () {
      const payload = {
        schedule_id: this.schedule_id
      }
      const { data } = await calenderNoteList(payload, this.customer_id)
      this.noteList = data.data.note
    }
  },
  mounted () {
    this.fetchCalenderNoteList()
  }
}
</script>